/* eslint-disable no-console */
import axios from 'axios';
import moment from 'moment';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import useUserStore from '../../../store/userStore/userStore';
import {APIType, APITypeEnum} from '../../interface/tableAPIType';
import {tableAPIMethod, getRouteIP} from '../../utils/tableAPIMethod';

import {EmpKey} from './../../../components/Forms/Constants/IP/EmpKeyLabel';

const empCommuteAPI = async (
  type: APIType,
  data: any = undefined,
  id: string = ''
): Promise<any> => {
  const token = useUserStore.getState().userToken;
  if (type === APITypeEnum.PUT) {
    delete data.company;
  }
  try {
    const response = await axios.request({
      method: tableAPIMethod(type),
      url: `${API_BASE_URL}${API_ENDPOINT_JSON.employee}/${getRouteIP(
        type,
        id
      )}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {},
      data: data ?? {}
    });

    if (type === APITypeEnum.GET_ALL) {
      return response.data.data.map((item: any) => {
        return {
          ...item,
          [EmpKey.DATE_JOINING]: item?.[EmpKey.DATE_JOINING]
            ? moment(item?.[EmpKey.DATE_JOINING])
            : undefined,
          [EmpKey.DATE_RESIGNING]: item?.[EmpKey.DATE_RESIGNING]
            ? moment(item?.[EmpKey.DATE_RESIGNING])
            : undefined
        };
      });
    } else {
      return response.data;
    }
  } catch (err) {
    console.log('err:', err);
  }
};

export default empCommuteAPI;
